import type { MaybeRefOrGetter } from 'vue';
import type { NavigationGuard } from 'vue-router';
import { useEventListener } from '@vueuse/core';
import { toValue } from 'vue';
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import { unsavedChangesWarningFlag } from '#layers/base/public';

export function useNavigationGuard(hasChanges: MaybeRefOrGetter<boolean>, guard: NavigationGuard) {
	useEventListener(window, 'beforeunload', (event) => {
		if (!unsavedChangesWarningFlag.value) return;

		if (toValue(hasChanges)) {
			event.preventDefault();
		}
	});

	onBeforeRouteUpdate(guard);
	onBeforeRouteLeave(guard);
}
